import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-f8cd59f6"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("span", {
    class: "imgcode-box",
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    function () {
      return _ctx.onClickBtn && _ctx.onClickBtn.apply(_ctx, arguments);
    })
  }, [_createElementVNode("img", {
    class: "code-image",
    src: _ctx.imageUrl
  }, null, 8, _hoisted_1), _renderSlot(_ctx.$slots, "tips", {}, undefined, true)]);
}